import { Dumbbell } from "lucide-react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  variant?: "default" | "modern";
};

function BrandingPanel() {
  return (
    <div className="relative hidden lg:flex lg:w-1/2 flex-col justify-between overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-950 p-12 text-white">
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 50%, rgba(16, 185, 129, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(52, 211, 153, 0.1) 0%, transparent 40%)",
        }}
      />

      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative z-10 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-500/20 ring-1 ring-emerald-400/30">
          <Dumbbell className="h-6 w-6 text-emerald-400" strokeWidth={2.5} />
        </div>
        <span className="text-xl font-bold tracking-tight">GymAPP</span>
      </div>

      <div className="relative z-10 space-y-6">
        <h1 className="text-4xl font-bold leading-tight tracking-tight xl:text-5xl">
          Gerencie sua academia com{" "}
          <span className="text-emerald-400">eficiência</span>
        </h1>
        <p className="max-w-md text-lg text-slate-300 leading-relaxed">
          Treinos, alunos e profissionais em um só lugar. Acesse sua conta e
          continue de onde parou.
        </p>

        <ul className="space-y-3 text-sm text-slate-400">
          {[
            "Gestão completa de alunos e fichas",
            "Acompanhamento de treinos em tempo real",
            "Painel intuitivo para sua equipe",
          ].map((item) => (
            <li key={item} className="flex items-center gap-2.5">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-400" />
              {item}
            </li>
          ))}
        </ul>
      </div>

      <p className="relative z-10 text-xs text-slate-500">
        © {new Date().getFullYear()} GymAPP. Todos os direitos reservados.
      </p>
    </div>
  );
}

export default function FormPublicWrapper({
  children,
  variant = "default",
}: Props) {
  if (variant === "default") {
    return (
      <div className="w-full flex justify-center items-center p-8 min-h-screen overflow-hidden bg-dark-background">
        <div className="w-full lg:max-w-lg">{children}</div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen overflow-hidden bg-slate-950">
      <BrandingPanel />

      <div className="relative flex w-full flex-1 flex-col items-center justify-center px-6 py-10 sm:px-10 lg:w-1/2">
        <div
          className="pointer-events-none absolute inset-0 lg:hidden"
          style={{
            background:
              "radial-gradient(ellipse 80% 50% at 50% -20%, rgba(16, 185, 129, 0.12), transparent)",
          }}
        />

        <div className="relative z-10 mb-8 flex items-center gap-2.5 lg:hidden">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-500/20 ring-1 ring-emerald-400/30">
            <Dumbbell className="h-5 w-5 text-emerald-400" strokeWidth={2.5} />
          </div>
          <span className="text-lg font-bold tracking-tight text-white">
            GymAPP
          </span>
        </div>

        <div className="relative z-10 w-full max-w-md">{children}</div>
      </div>
    </div>
  );
}
